<icon [name]="iconName" [class.icon-background]="showIconBackground" [svg]="iconSvg"></icon>
@if(allNeighborhoods.length > 1) {
<mat-select id="neighborhood-selector" [value]="neighborhood" (selectionChange)="handleNeighborhoodChange($event.value)">
  @for(hood of allNeighborhoods; track hood.NeighborhoodId) {
  <mat-option [value]="hood" [selected]="hood.NeighborhoodId === neighborhood.NeighborhoodId">
    {{hood.DisplayName}}
  </mat-option>
  }
</mat-select>
}@else {
<span>{{text}}</span>
}